<div class="topbar clearfix">
    <div class="topbar-left">
        <div class="app-switcher-wrapper" *ngIf="phanHes.length">
            <button type="button" class="app-switcher-btn" (click)="toggleAppSwitcher($event)"
                [class.active]="showAppSwitcher" pTooltip="Chuyển phân hệ" tooltipPosition="bottom"
                [attr.aria-expanded]="showAppSwitcher">
                <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="3" y="3" width="7" height="7" rx="1.5"></rect>
                    <rect x="14" y="3" width="7" height="7" rx="1.5"></rect>
                    <rect x="3" y="14" width="7" height="7" rx="1.5"></rect>
                    <rect x="14" y="14" width="7" height="7" rx="1.5"></rect>
                </svg>
            </button>

            <div class="app-switcher-mask" [class.show]="showAppSwitcher" (click)="closeAppSwitcher($event)"></div>
            <aside class="app-switcher-drawer" [class.open]="showAppSwitcher" (click)="$event.stopPropagation()"
                [attr.aria-hidden]="!showAppSwitcher">
                <div class="app-switcher-drawer-header">
                    <strong>Phân hệ</strong>
                    <button type="button" class="app-switcher-close" (click)="closeAppSwitcher($event)" aria-label="Đóng">
                        <i class="fa-light fa-times"></i>
                    </button>
                </div>

                <!-- Nhóm của app đang mở: lọc sidebar tại chỗ. Nhóm của app khác: mở app đó (cùng tab). -->
                <div class="app-switcher-section" *ngFor="let phanHe of phanHes">
                    <div class="app-switcher-section-title">
                        <span>{{phanHe.tenPhanHe}}</span>
                        <span class="app-switcher-current" *ngIf="phanHe.laAppHienTai">Đang mở</span>
                    </div>
                    <div class="app-switcher-grid">
                        <ng-container *ngFor="let nhom of phanHe.nhoms">
                            <button type="button" class="app-switcher-item" *ngIf="phanHe.laAppHienTai"
                                [class.selected]="nhom.ma === selectedGroupCode"
                                (click)="selectMenuGroup(nhom, $event)" [title]="nhom.ten">
                                <span class="app-switcher-icon" [ngClass]="'app-switcher-icon-' + (nhom.mauSac || 'blue')">
                                    <i [ngClass]="nhom.icon || 'fa-light fa-folder'"></i>
                                </span>
                                <span class="app-switcher-text">{{nhom.ten}}</span>
                            </button>
                            <a class="app-switcher-item" *ngIf="!phanHe.laAppHienTai"
                                [href]="buildGroupUrl(phanHe, nhom)" [title]="nhom.ten">
                                <span class="app-switcher-icon" [ngClass]="'app-switcher-icon-' + (nhom.mauSac || 'blue')">
                                    <i [ngClass]="nhom.icon || 'fa-light fa-folder'"></i>
                                </span>
                                <span class="app-switcher-text">{{nhom.ten}}</span>
                            </a>
                        </ng-container>
                    </div>
                </div>
            </aside>
        </div>
        <div class="topbar-logo-wrapper">
            <a href="/" (click)="app.onSwitchModule(1)"><img src="{{environment.appMetadata.appDomain.logo}}"
                    class="topbar-logo" /></a>
        </div>
    </div>


    <div class="topbar-right">
        <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)"
            [ngClass]="{'menu-button-rotate': app.rotateMenuButton}">
            <i class="fa-light fa-angle-right"></i>
        </a>

        <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
            <i class="fa-light fa-bars"></i>
        </a>

        <!-- <div class="breadcrumb breadcrumb-term">
            <a class="breadcrumb-item" (click)="showDialog()">
                <span class="text-xs"> {{mySetting.tenNamHoc}} / {{mySetting.khHocKy}} / {{mySetting.tenDotThi}}</span>
                <button type="button" class="btn" data-toggle="modal" data-target="#exampleModal">
                    <i class="fa-light fa-caret-down"></i>
                </button>
            </a>
        </div> -->

        <ul class="topbar-items fadeInDown" [ngClass]="{'topbar-items-visible': _commonService.topbarMenuActive}">
            <li #profile class="profile-item" *ngIf="app.profileMode==='top'||_commonService.isHorizontal()"
                [ngClass]="{'active-top-menu':_commonService.activeTopbarItem === profile}">

                <a href="#" (click)="_commonService.onTopbarItemClick($event,profile)" class="profile-item-inner">
                    <div class="profile-image-wrapper">
                        <img class="profile-image" src="{{avatarUrl}}" pTooltip="Thông tin cá nhân"
                            tooltipPosition="bottom" />
                    </div>
                    <div class="profile-info-wrapper">
                        <div class="topbar-item-name-wrapper"><span
                                class="topbar-item-name">{{crrUser?.displayName}}</span>
                        </div>
                        <!-- <div class="topbar-item-role-wrapper"><span class="topbar-item-role">{{position}}</span></div> -->
                    </div>
                </a>

                <ul class="layout-menu fadeInDown">
                    <li role="menuitem">
                        <a href="#" (click)="app.onEditInfo($event)">
                            <i class="fa-light fa-fw fa-user-edit"></i>
                            <span>Thông tin cá nhân</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="#" (click)="app.onChangePassword($event)">
                            <i class="fa-light fa-fw fa-key"></i>
                            <span>Đổi mật khẩu</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="javascript:;" (click)="app.onTopbarLogout($event)">
                            <i class="fa-light fa-fw fa-sign-out"></i>
                            <span>Đăng xuất</span>
                        </a>
                    </li>
                </ul>
            </li>
            <li #messages pTooltip="Hướng dẫn sử dụng" tooltipPosition="bottom">
                <a href="https://docs.mypha.vn" target="_blank" style="margin-right: 7px;">
                    <i class="fa-light fa-question-circle" style="color: #FFF; font-size: 25px;"></i>
                </a>
            </li>
            <li #messages [ngClass]="{'active-top-menu':_commonService.activeTopbarItem === messages}"
                vs-app-notification (openMenu)="_commonService.onTopbarItemClick($event,messages)" pTooltip="Thông báo"
                tooltipPosition="bottom">
            </li>
            <!-- <li pTooltip="Tin nhắn" tooltipPosition="bottom">
                <a [routerLink]="['/chat']" (click)="onMessagesClick()">
                    <i class="topbar-icon animated swing fa-light fa-fw fa-comment"></i>
                    <span class="topbar-badge animated rubberBand" *ngIf="mySetting.totalMessNotReaded > 0">{{mySetting.totalMessNotReaded}}</span>
                </a>
            </li> -->
            <li pTooltip="Tin nhắn" tooltipPosition="bottom">
                <a [routerLink]="['/chat']" (click)="onMessagesClick()">
                    <i class="fa-light fa-message" style="color: #FFF; font-size: 20px;"></i>
                    <span class="topbar-badge animated rubberBand"
                        *ngIf="mySetting.totalMessNotReaded > 0">{{mySetting.totalMessNotReaded}}</span>
                </a>
            </li>

            <app-vs-message-box></app-vs-message-box>


            <!-- <li class="balance">Số xu đang xử lý: <b class="number">
                    {{balanceBlock | vsnumber : 0}}
                    xu</b></li>
            <li class="balance">Số dư tài khoản: <b class="number"> {{balance | vsnumber : 0}}
                    xu</b></li> -->


            <li #search *ngIf="false" class="search-item" [hidden]="!_globalService.getSearchBoxState()"
                [ngClass]="{'active-top-menu':app.activeTopbarItem === search}" style="margin-right:10px;"
                (click)="_commonService.onTopbarItemClick($event,search)">
                <div class="ui-inputgroup" style="margin-top:-7px">
                    <button (click)="onTopbarSearchClick($event, input)" pButton type="button" icon="fa-light fa-search"
                        class="ui-button-secondary" style="border-right:0;color:#666"></button>
                    <input #input (keyup.enter)="onTopbarSearchClick($event, input)" type="text" pInputText
                        placeholder="Nhập từ khóa" style="height:35px" [(ngModel)]="searchKey">
                </div>
            </li>
        </ul>
    </div>
</div>
<!-- 
<p-dialog header="Thiết lập tham số hệ thống" [(visible)]="display" [modal]="true" [responsive]="true" [width]="500"
    [closeOnEscape]="true" [dismissableMask]="true" [minY]="70" [baseZIndex]="1008" [closable]="true"
    [dismissableMask]="true" [showHeader]="true" [resizable]="true">
   

    <div class="vs-form-container default-control-label-width vs-modal-content-panel">
        <div class="vs-form-container default-control-label-width">

            <div class="ui-g row">
                <div class="ui-g-12 ui-lg12">
                    <div class="vs-form-control ui-g">
                        <div class="__form-control-label ui-g-12 ui-md-4">Năm học</div>
                        <div class="__form-control-inputs ui-g-12 ui-md-8">
                            <div class="__input-wrapper">
                                <p-dropdown [baseZIndex]="15000" [(ngModel)]="mySettingEdit.idNamHoc"
                                    (onChange)="onChangeNamHoc()"
                                    [emptyFilterMessage]="'Không tìm thấy kết quả'"
                                    [options]="namHoc_options" [style]="{'width':'100%', 'min-width':'0'}"
                                    appendTo="body"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ui-g-12 ui-lg-12">
                    <div class="vs-form-control ui-g">
                        <div class="__form-control-label ui-g-12 ui-md-4">Học kỳ</div>
                        <div class="__form-control-inputs ui-g-12 ui-md-8">
                            <div class="__input-wrapper">
                                <p-dropdown [baseZIndex]="15000" [(ngModel)]="mySettingEdit.idHocKy"
                                    (onChange)="onChangeNamHoc()"
                                    [emptyFilterMessage]="'Không tìm thấy kết quả'"
                                    [options]="hocKy_options" [style]="{'width':'100%', 'min-width':'0'}"
                                    appendTo="body"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ui-g-12 ui-lg-12">
                    <div class="vs-form-control ui-g">
                        <div class="__form-control-label ui-g-12 ui-md-4">Đợt thi</div>
                        <div class="__form-control-inputs ui-g-12 ui-md-8">
                            <div class="__input-wrapper">
                                <p-dropdown [baseZIndex]="15000" [(ngModel)]="mySettingEdit.idDotThi"
                                    [emptyFilterMessage]="'Không tìm thấy kết quả'"
                                    [options]="dotThi_options" [style]="{'width':'100%', 'min-width':'0'}"
                                    appendTo="body"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <p-footer>
        <button type="button" class="ui-button-primary " pButton icon="pi pi-save" (click)="onSaveSettings()"
            label="Lưu lại"></button>
        <button type="button" pButton icon="pi pi-times" (click)="onReturn()" label="Đóng"
            class="ui-button-secondary"></button>
    </p-footer>
</p-dialog> -->